@if (onboarding.step() === 'path') {
  <div #stepScroller class="h-full flex-1 overflow-y-auto">
    <vf-path-step class="h-full" />
  </div>
} @else {
  <div [class]="frameClass()">
    <div [class]="columnClass()">
      <header class="sticky top-0 z-10 flex h-14 shrink-0 items-center justify-between gap-3 border-b border-border bg-background px-4 sm:h-16 sm:px-8">
        <div class="flex min-w-0 items-center gap-3">
          @if (onboarding.showBack()) {
            <button type="button" class="btn-shout-fab-secondary" (click)="goBack()" aria-label="Back">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-5" aria-hidden="true">
                <path d="M19 12H5" />
                <path d="m12 19-7-7 7-7" />
              </svg>
            </button>
          }
          <img src="/assets/logos/official/SHOUT_studio_logo_full_colour_black.svg" alt="SHOUT Studio" class="h-7 w-auto dark:hidden" />
          <img src="/assets/logos/official/SHOUT_studio_logo_full_colour_white.svg" alt="" class="hidden h-7 w-auto dark:block" />
        </div>
        @if (onboarding.progress()) {
          <p class="m-0 text-base font-bold text-muted-foreground">Step {{ onboarding.progress() }} of 3</p>
        }
      </header>

      @if (onboarding.progress()) {
        <div class="mt-2.5 flex shrink-0 gap-1 px-4 sm:px-8" aria-hidden="true">
          @for (segment of [1, 2, 3]; track segment) {
            <div class="h-1 flex-1 rounded-sm" [class]="segment <= (onboarding.progress() || 0) ? 'bg-primary' : 'bg-muted'"></div>
          }
        </div>
      }

      <main #stepScroller [class]="mainClass()">
        @switch (onboarding.step()) {
          @case ('website') { <vf-website-step /> }
          @case ('manual') { <vf-manual-step /> }
          @case ('found') { <vf-found-step /> }
          @case ('email') { <vf-email-step /> }
          @case ('code') { <vf-code-step /> }
          @case ('account') { <vf-account-step /> }
          @case ('welcome') { <vf-welcome-step /> }
        }
      </main>
    </div>
    <vf-workspace-panel />
  </div>
}
